<template>
    <section class="hero is-fullheight login" style="height:100%">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <article class="card is-rounded">
<!--                        <div class="card-content">
                            <h1 class="title">
                                &lt;!&ndash;<img src="/img/bg_login_title.png" alt="">&ndash;&gt;
                            </h1>
                            <p class="control has-icon">
                                <input v-model="loginInfo.loginId"
                                       autocomplete="name"
                                       class="input" type="text" name="username"
                                       placeholder="사번" autofocus="">
                                <i class="fa fa-envelope"></i>
                            </p>
                            <p class="control has-icon">
                                <input v-model="loginInfo.loginPw"
                                       autocomplete="new-password"
                                       class="input" type="password" name="password"
                                       placeholder="비밀번호" @keydown.enter="login">
                                <i class="fa fa-lock"></i>
                            </p>
                            <p class="control">
                                <button class="button is-fullwidth btn-login" @click="login">Login</button>
                            </p>
                        </div>-->
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        loginId: {
            type: String,
            required: false,
        },
        token: {
            type: String,
            required: false,
        },
    },
    name: 'Login',
    data() {
        return {
            loginInfo: {
                loginId: '',
                loginPw: '',
                compCd: '',
                loginDeptNm: '',
                loginDeptCd: '',
                loginDutCd: '',
                loginDutNm: '',
                loginJobCd: '',
                loginJobNm: '',
                token: '',
                menu: [],
                authorities: [],
            },
        }
    },
    methods: {
        loginFail() {
            this.$swal({
                animation: false,
                type: 'error',
                text: `로그인 실패했습니다. ID 또는 비밀번호를 확인해 주세요.`,
            });
        },
        async login() {
            try {
                this.$store.commit('loading');
                const response = await this.$http.post('/login', this.loginInfo);

                const loginInfo = {};
                loginInfo.userName = response.data.userName;
                loginInfo.loginId = response.data.loginId;
                loginInfo.compCd = response.data.loginCompCd;
                loginInfo.loginDeptNm = response.data.loginDeptNm;
                loginInfo.loginDeptCd = response.data.loginDeptCd;
                loginInfo.loginDutCd = response.data.loginDutCd;
                loginInfo.loginDutNm = response.data.loginDutNm;
                loginInfo.loginJobCd = response.data.loginJobCd;
                loginInfo.loginJobNm = response.data.loginJobNm;
                loginInfo.token = response.data.token;
                loginInfo.menu = response.data.menu;
                loginInfo.authorities = response.data.authorities;
                loginInfo.loginPw = 'Not Use';

                this.$store.commit('login', loginInfo);
                this.$cookie.set('loginInfo', JSON.stringify(loginInfo));
                this.$http.defaults.headers['x-auth-token'] = loginInfo.token;
                this.$store.commit('finish');
            } catch(err) {
                console.log(err)
                this.$store.commit('finish');
                this.loginFail();
            }
        },
        signOut() {
            var auth2 = gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                console.log('User signed out.');
            });
        },
        async socialLogin() {
            console.log("Now Loged in!!!!")
            try {
                this.$store.commit('loading');
                const response = await this.$http.post('/login/sso', this.loginInfo);
                const loginInfo = {};
                loginInfo.userName = response.data.userName;
                loginInfo.loginId = response.data.loginId;
                loginInfo.compCd = response.data.loginCompCd;
                loginInfo.loginDeptNm = response.data.loginDeptNm;
                loginInfo.loginDeptCd = response.data.loginDeptCd;
                loginInfo.loginDutCd = response.data.loginDutCd;
                loginInfo.loginDutNm = response.data.loginDutNm;
                loginInfo.loginJobCd = response.data.loginJobCd;
                loginInfo.loginJobNm = response.data.loginJobNm;
                loginInfo.token = response.data.token;
                loginInfo.menu = response.data.menu;
                loginInfo.authorities = response.data.authorities;
                loginInfo.loginPw = 'Not Use';

                this.$store.commit('login', loginInfo);
                this.$cookie.set('loginInfo', JSON.stringify(loginInfo));
                this.$cookie.set('sessionAlive', true);
                this.$http.defaults.headers['x-auth-token'] = loginInfo.token;
                this.$store.commit('register', '');
                this.$router.push({path: `/backOffice`});
                this.$store.commit('finish');
            } catch(err) {
                this.$store.commit('finish');
                this.loginFail();
            }
        }
    },
    created() {
        this.loginId = this.$route.query['loginId'];
        this.token = this.$route.query['token'];

        if(this.loginId === undefined || this.loginId === '') {
/*
            // Step.1 - 초기화
            rathonsso.init();

            // Step.2 - SSO 인증 & 갱신
            // true: Authentication Required
            // false: Authentication Successful
            let result = rathonsso.requestAuthentication()
            //console.log("requestAuthentication: " + result)
            if(!result) {
                // '/login/sso' 호출
                this.socialLogin()
            }
*/
          this.$router.push({path: `/loginM`});
        }

        this.loginInfo.loginId = this.loginId;
        this.loginInfo.token = this.token;

        //모바일 iframe 메시지 수신을 통한 로그인
        window.addEventListener('message', async event => {
            // console.log(event.data.id);
            if(event.origin === process.env.VUE_APP_MO_URL) {
                // console.log(`pc:event.origin : ${event.origin}`)
                if(event.data.message === 'isPcLogin') {

                    const ret = this.$store.state.loginInfo !== null && this.$store.state.token !== '';
                    window.parent.postMessage({
                        message: 'pcLogin',
                        value: ret
                    }, '*');
                    console.log('pc:isPcLogin 수신 후 pcLogin' + ret + '보냄');

                } else if(event.data.message === 'login') {

                    console.log('pc:login 하라는 메시지 받음');

                    if(!this.$store.state.loginInfo) { //로그인 안되어있다면
                        this.loginInfo.loginId = event.data.loginId;
                        this.loginInfo.loginPw = event.data.loginPw;
                        await this.login();
                        const ret = this.$store.state.loginInfo !== null && this.$store.state.token !== '';

                        window.parent.postMessage({
                            message: 'pcLogin',
                            value: ret
                        }, '*');
                        console.log('pc:현재 로그인 안되어있어서 로그인 시키고 pcLogin:' + ret + ' 메시지 보냄');

                    } else {
                        window.parent.postMessage({
                            message: 'pcLogin',
                            value: true
                        }, '*');
                        console.log('pc:현재 로그인 되어있어서 pcLogin true 메시지 보냄');
                    }
                }
            }
        })
    },
    beforeMount() {
        // 페이지 리로드를 위해 localStorage에 vuex 제거
        localStorage.removeItem('vuex');

        console.log("this.token : " + this.token);
        if(this.token) {
            if(this.token == "null") {
                this.$store.state.oauthNew = 'new';
                //this.$router.push({path:`/oauth/new`});

            } else {
                console.log("Now redirect MainPage...")
                this.socialLogin();
            }
        }
    },
};
</script>
<style lang="scss" scoped>
@import "public/css/bulma";
/* main layout */
.login{display:table; width:100%; justify-content:center; align-items:center;  background:url("/img/lem_main_full.jpg") no-repeat center center; background-size:cover;}
.login .hero-body{display:table-cell!important; vertical-align:middle;}
.login-box{width:370px; margin:0 auto; background:url("/img/bg_login_title.png") no-repeat center center;}
.btn-login{background:#f05f52; color:#fff; height:56px; border:none; border-radius:30px; font-size:20px; font-family:"RobotoM";}
.btn-login:hover{color:#fff;}
.footer-login{position:absolute; left:0; right:0; bottom:0; width:100%; min-width:1280px; height:59px; line-height:59px; font-size:11px; text-align:center; color:#fff; background:#404040; font-family:'NotoM';}
.footer-login .copyright{opacity:.5;}

/* custom */
.card{background-color:transparent; box-shadow:inherit;}
.card-content{padding:0;}
.card-content h1.title{margin-bottom:30px;}
.control.has-icon > input{margin-bottom:18px; padding-left:88px; background:transparent; font-size:16px; border-radius:30px; height:56px; border-color:#fff; color:#fff;}
.control.has-icon > input::placeholder{color:#fff;}
.control.has-icon > i{position:absolute; top:20px; left:43px; color:#fff;}
</style>
